<div id="bannerJuncture" class="container">
  <div class="row content" (click)="flagService.bannerVisible = !flagService.bannerVisible">
    <div class="col-12 p-0">
      <div class="component-header pointer language-container" [ngClass]="{ 'closed': !flagService.bannerVisible }">
        <h3 class="label m-0">{{ (dataService.isKompakt() ? 'dropDown.title.kompakt' : 'dropDown.title.notKompakt') | translate }}</h3>
        @if (dataService.hasEnglishVersion) {
          <div class="label language-selector">
            <span class="language-text" (click)="setLanguage('hu', $event)">HU</span>|<span class="language-text" (click)="setLanguage('en', $event)">EN</span>
          </div>
        }
      </div>
    </div>
    @if (flagService.bannerVisible) {
      <div class="col-12 p-0" @openClose style="overflow: hidden;">
        <div class="banner" [ngClass]="{ 'kompakt': dataService.isKompakt() }">
          <div class="img-container text-center">
            @if (imagePath) {
              <div class="mx-auto mb-4">
                <img class="logo" [src]="imagePath">
              </div>
            }
            @if (!imagePath) {
              <fa-icon class="faBan" [icon]="faBan"></fa-icon>
            }
          </div>
          @if (contractorName) {
            <h1 class="text-center fw-bold text-uppercase mb-0">{{ contractorName }}</h1>
          }
          @if (!dataService.isKompakt()) {
            <img src="assets/banner/PrivatemedNext-banner-640-kep.png" class="kompakt-img">
            <app-banner-info
              [title]="'missing.banner.notKompakt.title' | translate"
            [items]="[
              'missing.banner.notKompakt.line-1' | translate,
              'missing.banner.notKompakt.line-2' | translate,
              'missing.banner.notKompakt.line-3' | translate,
              'missing.banner.notKompakt.line-4' | translate,
              'missing.banner.notKompakt.line-5' | translate,
              ]"></app-banner-info>
          }
          @if (dataService.isKompakt()) {
            <img src="assets/banner/Kompakt-banner-640-kep.png" class="kompakt-img">
            <app-banner-info
              [title]="'missing.banner.kompakt.title' | translate"
            [items]="[
              'missing.banner.kompakt.line-1' | translate,
              'missing.banner.kompakt.line-2' | translate,
              'missing.banner.kompakt.line-3' | translate,
              'missing.banner.kompakt.line-4' | translate,
              'missing.banner.kompakt.line-5' | translate,
              ]"></app-banner-info>
          }
        </div>
      </div>
    }
  </div>
</div>
<div class="banner-info-fix container" #fixInfoContainer>
  @if (!dataService.isKompakt()) {
    <span>
      {{ 'junctures.banner.info.notKompakt' | translate:{ contractorName } }}
    </span>
  }
  @if (dataService.isKompakt()) {
    <span>
      {{ 'junctures.banner.info.kompakt' | translate:{ contractorName } }}
    </span>
  }
</div>
